import { toast } from "react-toastify";
import axios from "axios";
import { BACKEND } from "../../config/configEnvs";

const GenerarPagosTrabajadores = async (mes, año, getPayments, worker = null) => {
  try {
    // Si es un trabajador nuevo, generamos los pagos para su contrato
    if (worker) {
      const toastId = toast.loading("Generando pagos...");

      const startDate = new Date(worker.fechaInicioContrato);
      const endDate = worker.fechaFinContrato ? new Date(worker.fechaFinContrato) : null;
      
      // Si no hay fecha fin, generamos pagos por 6 meses
      if (!endDate) {
        const sixMonthsLater = new Date(startDate);
        sixMonthsLater.setMonth(sixMonthsLater.getMonth() + 6);
        endDate = sixMonthsLater;
      }
      
      // Generar pagos desde la fecha de inicio hasta la fecha de fin
      const payments = [];
      let currentDate = new Date(startDate);
      
      while (currentDate <= endDate) {
        const month = currentDate.getMonth() + 1;
        const year = currentDate.getFullYear();
        
        // Verificar si ya existe un pago para este mes
        const response = await axios.get(`${BACKEND}/api/pagosTrabajadores?limit=0&where[worker][equals]=${worker.id}&where[month][equals]=${Number(month)}&where[year][equals]=${Number(year)}`);
        
        if (response.data.totalDocs === 0) {
          // Calcular el último día del mes
          const lastDay = new Date(year, month, 0).getDate();
          const paymentDate = new Date(year, month - 1, lastDay);
          
          await axios.post(`${BACKEND}/api/pagosTrabajadores`, {
            worker: worker.id,
            month: Number(month),
            year: Number(year),
            amount: worker.sueldo,
            payed: false,
            datePayment: paymentDate.toISOString()
          });
          
          payments.push({ month: Number(month), year: Number(year) });
        }
        
        // Avanzar al siguiente mes
        currentDate.setMonth(currentDate.getMonth() + 1);
      }
      
      if (payments.length > 0) {
        toast.update(toastId, { 
          render: `Se generaron ${payments.length} pagos para ${worker.name}${!worker.fechaFinContrato ? ' (por 6 meses)' : ''}`, 
          type: "success",
          isLoading: false, 
          autoClose: 3000 
        });
      }
      return;
    }

    // No se utilizará este código, se utilizará el de arriba
    // Código existente para generar pagos para todos los trabajadores
    const confirmed = window.confirm("¿Estás seguro de que deseas generar los pagos automaticamente para el mes de " + mes + " del año " + año + "?");

    if (!confirmed) {return}

    // const response = await axios.get(`${BACKEND}/api/pagosTrabajadores?limit=0&where[month][equals]=${mes}&where[year][equals]=${año}`);
    // if (response.data.totalDocs !== 0){
    //   toast.info("Ya hay pagos generados para este mes y año");
    //   return;
    // }

    if (!mes || !año) {
      toast.error("No se puede generar pagos sin mes y año");
      return;
    }

    const responseWorkers = await axios.get(`${BACKEND}/api/trabajadores?limit=0&where[activo][equals]=true`);
    const workers = responseWorkers.data.docs.filter(w => 
      w.puesto.toUpperCase() !== "GERENTE GENERAL" && 
      w.puesto.toUpperCase() !== "JEFE DE PROYECTOS"
    );

    // Obtener los pagos existentes para el mes y año
    const responsePayments = await axios.get(`${BACKEND}/api/pagosTrabajadores?limit=0&where[month][equals]=${mes}&where[year][equals]=${año}`);
    const existingPayments = responsePayments.data.docs;

    // Filtrar trabajadores que no tengan pagos en el mes
    const workersWithoutPayments = workers.filter(worker => 
      !existingPayments.some(payment => payment.worker.id === worker.id)
    );

    if (workersWithoutPayments.length === 0) {
      toast.info("Todos los trabajadores ya tienen pagos generados para este mes");
      return;
    }

    const startDate = new Date(`${año}-${mes}-01`);
    const endDate = new Date(`${año}-${mes}-01`);
    endDate.setMonth(endDate.getMonth() + 1);
    endDate.setDate(endDate.getDate());

    const paymentsPromises = workersWithoutPayments.map(async (w) => {
      try {

        // Calcular el último día del mes
        const lastDay = new Date(año, mes, 0).getDate();
        const paymentDate = new Date(año, mes - 1, lastDay);

        await axios.post(`${BACKEND}/api/pagosTrabajadores`, {
          worker: w.id,
          month: Number(mes),
          year: Number(año),
          amount: w.sueldo,
          payed: false,
          datePayment: paymentDate.toISOString()
        });
        getPayments()
        return { success: true, worker: w.name };
      } catch (error) {
        console.error(`Error al generar pago para ${w.name}:`, error);
        return { success: false, worker: w.name, error: error.message };
      }
    });

    const results = await Promise.all(paymentsPromises);
    const successfulPayments = results.filter(r => r.success);
    const failedPayments = results.filter(r => !r.success);

    if (failedPayments.length > 0) {
      toast.warning(`Se generaron ${successfulPayments.length} pagos exitosamente, pero ${failedPayments.length} fallaron.`);
    } else {
      toast.success(`Se generaron ${successfulPayments.length} pagos exitosamente.`);
    }
  } catch (error) {
    console.error("Error al generar pagos de trabajadores:", error);
    throw error;
  }
}

export default GenerarPagosTrabajadores;